import type { ReviewSetDto } from '@nsb/core';
import { dateWords } from '../../days.ts';

/** An iteration's row as the list draws it: its number and title, and where it stands, for the one reading it. */
export function IterationHead({ set: s, staff }: { set: ReviewSetDto; staff: boolean }) {
  const draft = !s.sharedAt;
  const waitingOn = s.reviewers.filter((r) => !r.doneAt).map((r) => r.name);
  const state = draft
    ? 'Draft · only NSB sees it'
    : s.reviewed
      ? `Shared ${dateWords(s.sharedAt, 'date')} · reviewed by everyone asked`
      : staff && waitingOn.length
        ? `Shared ${dateWords(s.sharedAt, 'date')} · waiting on ${waitingOn.join(' and ')}`
        : `Shared ${dateWords(s.sharedAt, 'date')}`;
  return (
    <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1">
      <h3 className="font-display text-[1.25rem] leading-snug">
        <span className="label mr-3 align-middle">Iteration {s.iteration}</span>
        {s.title}
      </h3>
      <span className={`label ${draft ? '!text-cedar' : ''}`}>{state}</span>
    </div>
  );
}
